import router from '@/router';
import { EditorEvents } from '@/components/richEditor/config';
import i18n from '@/plugins/i18n';
export const NoteDefaultTitle = i18n.global.t('summary.title_placeholder');

export const NoteSearchMode = {
  /**
   * Normal 普通维度数据查询
   */
  Normal: 'normal',

  /**
   * Stock 根据个股维度数据查询
   */
  Stock: 'stock',

  /**
   * Industry 根据行业数据查询
   */
  Industry: 'industry'
};

export const NotePageType = {
  /**
   * 笔记的入口，从【路演页面】打开的笔记
   */
  Roadshow: 'roadshow',

  /**
   * 笔记的入口，从【纪要页面】打开的笔记
   */
  SmallSummaryNote: 'smallSummaryNote',
  /**
   * 笔记的入口，从【我的笔记】打开的笔记
   */
  MyNote: 'myNote',

  AiNote: 'aiNote', //AI会记

  MeetingNote: 'meetingNote' //会议纪要
};

export const NoteType = {
  /**
   * 0 未命名
   */
  unKown: 0,
  /**
   * 1 路演笔记
   */
  roadshowNote: 1,
  /**
   * 2 研报笔记
   */
  summaryNote: 2,

  /**
   * 3 调研笔记
   */
  searchNote: 3,
  /**
   * 6 纪要笔记
   */
  smallSummaryNote: 6,

  0: i18n.global.t('common.filter.other'),
  1: i18n.global.t('summary.roadshow_notes'),
  2: i18n.global.t('summary.research_report_notes'),
  3: i18n.global.t('summary.research_notes'),
  6: i18n.global.t('summary.meeting_notes')
};

export const NOTE_SAVE_STATUS = {
  // 保存中
  saving: 0,
  // 已保存
  saved: 1,
  // 保存失败
  failed: 2
};

const EventName = {
  ...Object.keys(EditorEvents).reduce((acc, key) => {
    acc[key] = () => {};
    return acc;
  }, {}),

  /**
   * 打开编辑器
   */
  openEditor() {},

  /**
   * 编辑器 跳转到列表
   */
  openList() {},

  /**
   * note发生变更,如删除 更新标题，更新个股，需要更新ui
   */
  refreshNote() {},

  /**
   * 摘抄笔记
   */
  appendNote() {},

  /**
   * 笔记保存状态消息通知
   */
  saveStatus() {}
};

export class Note {
  constructor() {
    if (Note.instance) {
      return Note.instance;
    }

    this.focus = false; // 编辑器
    this.addListener = this.addListener.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.formatEventName = this.formatEventName.bind(this);
    return this;
  }

  eventHandler = {};

  formatEventName(name) {
    const routerInfo = router?.currentRoute || {};
    const prefix = routerInfo?.fullPath || '';
    return `${prefix}/${name}`;
  }
  addListener(name, handler) {
    if (!(name in EventName)) {
      return console.error('addListener warning: eventName "' + name + '" is undefined');
    }

    const eventName = this.formatEventName(name);

    if (!this.eventHandler[eventName]) {
      this.eventHandler[eventName] = [];
    }
    this.eventHandler[eventName].push(handler);
  }

  removeListener(name, handler = null) {
    if (!(name in EventName)) {
      return console.error('removeListener warning: eventName "' + name + '" is undefined');
    }

    const eventName = this.formatEventName(name);

    if (handler) {
      const eventList = this.eventHandler[eventName];
      const index = eventList ? eventList.findIndex((event) => event === handler) : -1;
      index >= 0 && eventList.splice(index, 1);
    } else {
      delete this.eventHandler[eventName];
    }
  }

  dispatchEvent(name, ...params) {
    const eventName = this.formatEventName(name);
    if (!(eventName in this.eventHandler)) {
      return {
        code: -1,
        message: 'eventName "' + eventName + '" is undefined'
      };
    }
    this.eventHandler[eventName].forEach((handler) => {
      handler(...params);
    });
  }

  setFocusStatus(val) {
    this.focus = val;
  }

  getFocusStatus() {
    return this.focus;
  }
}

export const note = new Note();
const install = (app) => {
  app.config.globalProperties.$note = note;
};

export default install;
